import clsx from 'clsx';
import React from 'react';

interface MediaHoverLinkProps {
  text: string;
  url: string;
  position?: string;
}

export default function MediaHoverLink({
  text,
  url,
  position = 'bottom-0 right-0',
}: MediaHoverLinkProps) {
  return (
    <div
      className={clsx([
        'absolute bg-white text-orange-500 rounded-lg px-2 py-1 m-4 z-10 opacity-0 group-hover:opacity-100 hover:bg-orange-500 hover:text-white transition-all duration-300',
        position,
      ])}
    >
      <a href={url}>{text}</a>
    </div>
  );
}
